import SilenceSound from "../assets/silence.mp3";
import { logger } from "../utils";

export interface AudioAsset {
  name: string;
  content: any;
  loop?: boolean;
}

export class AudioService {
  audios: { [name: string]: HTMLAudioElement } = {
    silence: this.createAudioElement(SilenceSound)
  };

  constructor(assets: AudioAsset[]) {
    assets.forEach((el) => (this.audios[el.name] = this.createAudioElement(el.content, !!el.loop)));
  }

  init() {
    this.play("silence");
  }

  protected play(name: string) {
    if (name in this.audios) {
      this.audios[name]!.play().catch((error) => {
        // probably Auto-play was prevented
        logger.warn({message: "Play failed", error});
      });
    }
  }

  protected stop(name: string) {
    if (name in this.audios) {
      this.audios[name]!.pause();
      this.audios[name]!.currentTime = 0;
    }
  }

  private createAudioElement(src: string, loop?: boolean): HTMLAudioElement {
    const audio = document.createElement("audio");
    audio.src = src;
    audio.preload = "auto";
    audio.loop = !!loop;
    return audio;
  }
}
